<template lang="pug">
.Minimap
  .character(
    v-for="character, i in textCharacters"
    :class=`{
      inputted: (i + 1) <= playerPosition,
      ghostInputted: (i + 1) <= ghostPosition
    }`
  )
    | {{ character }}

</template>

<script>
// import moment from 'moment'
// import soundService from '@/services/SoundService'

export default {
  name: 'km-minimap',
  components: {},
  props: ['text', 'playerPosition', 'ghostPosition'],
  data() {
    return {}
  },
  computed: {
    textCharacters: function() {
      return this.text ? this.text.split('') : []
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.Minimap {
  padding: 0 0 100px 0;
}

.character {
  display: inline-block;

  &.ghostInputted {
    background: red;
  }
  &.inputted {
    background: orange;
  }
}
</style>
